module.exports = __webpack_public_path__ + "img/CollateralList.1d2d35e2.svg";